<template>
  <div class="card" v-if="invoices.length > 0">
    <div class="card-header">
      <h3>Past Invoices</h3>
    </div>
    <div class="card-body">
      <table class="table account-invoices-table">
        <thead class="thead-dark">
          <tr>
            <th scope="col">#</th>
            <th scope="col">Date</th>
            <th scope="col">Status</th>
            <th scope="col">Total</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="invoice in invoices" :key="invoice.id">
            <td>{{ invoice.id }}</td>
            <td>{{ invoice.date }}</td>
            <td>{{ invoice.status }}</td>
            <td>{{ invoice.total }}</td>
            <td>
              <a :href="invoice.download_url" class="btn btn-sm btn-secondary">
                Download
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'account-invoices',
  computed: {
    invoices() {
      return this.$store.getters.invoices
    }
  },
  created() {
    this.$store.dispatch('fetchInvoices')
  }
}
</script>

<style lang="scss">
.account-invoices-table {
  td {
    vertical-align: middle;
    &:last-child {
      text-align: right;
    }
  }
}
</style>
